/* ============================================================
   OJI V4 PDP — motion choreography, shop logic, AJAX cart
   Adapted from product-page-sample/main.js (SplitText replaced
   by Liquid-pre-wrapped .line-mask/.line spans; demo cart
   replaced by Shopify AJAX Cart API)
   ============================================================ */
(function () {
  "use strict";
  document.documentElement.classList.add("oji-v4-js");

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var root = document.querySelector(".oji-v4");
  if (!root) return;

  /* ---------- Config from Liquid ---------- */
  var cfg = window.OjiV4 || {};
  var moneyFormat = cfg.moneyFormat || "${{amount}}";
  var freeShipCents = Number(cfg.freeShipCents || 0);

  function fmt(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, "");
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* ---------- Shop state from DOM ---------- */
  var bundleInputs = document.querySelectorAll('.oji-v4 input[name="id"][data-bundle]');
  var state = { variantId: null, priceCents: 0, label: "", qty: 1 };
  var checked = document.querySelector('.oji-v4 input[name="id"][data-bundle]:checked');
  if (checked) {
    state.variantId = checked.value;
    state.priceCents = Number(checked.dataset.priceCents);
    state.label = checked.dataset.label;
  }

  /* ============================================================
     SMOOTH SCROLL (Lenis) + GSAP setup
     ============================================================ */
  var lenis = null;
  if (!prefersReduced && window.Lenis) {
    lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    window.lenis = lenis;
    lenis.on("scroll", function () { if (window.ScrollTrigger) ScrollTrigger.update(); });
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
  }
  if (window.gsap && window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll('.oji-v4 a[href^="#"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      var target = document.querySelector(a.getAttribute("href"));
      if (!target) return;
      e.preventDefault();
      if (lenis) lenis.scrollTo(target, { offset: -20, duration: 1.4 });
      else target.scrollIntoView({ behavior: "smooth" });
    });
  });

  /* ============================================================
     INTRO + SCROLL CHOREOGRAPHY
     ============================================================ */
  function initMotion() {
    var heroLines = document.querySelectorAll("#oji-v4-hero-title .line");
    var tl = gsap.timeline({ defaults: { ease: "power3.out" } });
    tl.to(".oji-v4 .hero__eyebrow", { opacity: 1, duration: 0.7 }, 0.35);
    if (heroLines.length) tl.from(heroLines, { yPercent: 110, duration: 1.15, stagger: 0.12, ease: "expo.out" }, 0.4);
    /* OJI FIX 2026-08-18 (auditoría CRO/LCP): .hero__actions y .hero__trust ya no se animan
       (nacen visibles — el CTA no puede depender de GSAP ni de fonts.ready) y la lata entra
       solo por transform, sin opacidad: es el elemento LCP y un fromTo con opacity:0 la
       re-ocultaba en el primer frame de la animación. */
    tl.to(".oji-v4 .hero__sub", { opacity: 0.85, duration: 0.9 }, 0.85)
      .fromTo("#oji-v4-hero-tin", { y: 60, rotate: 3 }, { y: 0, rotate: 0, duration: 1.4, ease: "expo.out" }, 0.55)
      .fromTo(".oji-v4 .hero__disc", { scale: 0.7, opacity: 0 }, { scale: 1, opacity: 1, duration: 1.6, ease: "expo.out" }, 0.4)
      .to(".oji-v4 .hero__chip", { opacity: 1, duration: 0.8 }, 1.3);

    if (document.getElementById("oji-v4-hero-tin")) {
      gsap.to("#oji-v4-hero-tin", { y: -14, duration: 3.2, ease: "sine.inOut", yoyo: true, repeat: -1, delay: 2 });
      gsap.to(".oji-v4 .hero__visual", { y: -60, scrollTrigger: { trigger: ".oji-v4 .hero", start: "top top", end: "bottom top", scrub: 1.2 } });
      gsap.to(".oji-v4 .hero__kanji", { y: 80, scrollTrigger: { trigger: ".oji-v4 .hero", start: "top top", end: "bottom top", scrub: 1.6 } });
    }

    var track = document.getElementById("oji-v4-marquee-track");
    if (track) {
      track.innerHTML += track.innerHTML + track.innerHTML;
      gsap.to(track, { xPercent: -33.333, duration: 26, ease: "none", repeat: -1 });
    }

    gsap.utils.toArray(".oji-v4 .fade-up").forEach(function (el) {
      gsap.to(el, {
        opacity: el.matches("p") ? 0.88 : 1, y: 0, duration: 1.1, ease: "power3.out",
        scrollTrigger: { trigger: el, start: "top 84%" }
      });
    });

    gsap.utils.toArray(".oji-v4 .reveal-img").forEach(function (fig) {
      var img = fig.querySelector("img");
      gsap.fromTo(fig,
        { clipPath: "inset(12% 8% 12% 8% round 2rem)" },
        { clipPath: "inset(0% 0% 0% 0% round 2rem)", duration: 1.4, ease: "expo.out", scrollTrigger: { trigger: fig, start: "top 82%" } });
      if (img) gsap.to(img, { scale: 1, duration: 1.8, ease: "expo.out", scrollTrigger: { trigger: fig, start: "top 82%" } });
    });

    ScrollTrigger.matchMedia({
      "(min-width: 861px)": function () {
        var steps = gsap.utils.toArray(".oji-v4 .ritual__step");
        if (!steps.length) return;
        ScrollTrigger.create({
          trigger: ".oji-v4 .ritual__pin", start: "top top", end: "+=2400", pin: true, scrub: true,
          onUpdate: function (self) {
            var i = Math.min(3, Math.floor(self.progress * 4));
            steps.forEach(function (s, j) { s.classList.toggle("is-active", j === i); });
          }
        });
      }
    });

    var outroLines = document.querySelectorAll("#oji-v4-outro-title .line");
    if (outroLines.length) {
      gsap.from(outroLines, {
        yPercent: 110, duration: 1.2, stagger: 0.12, ease: "expo.out",
        scrollTrigger: { trigger: ".oji-v4 .outro", start: "top 70%" }
      });
    }
    if (document.querySelector(".oji-v4 .outro__kanji")) {
      gsap.from(".oji-v4 .outro__kanji", {
        scale: 0.85, opacity: 0, duration: 2, ease: "expo.out",
        scrollTrigger: { trigger: ".oji-v4 .outro", start: "top 75%" }
      });
    }

    ScrollTrigger.batch(".oji-v4 .review", {
      start: "top 88%",
      onEnter: function (batch) { gsap.to(batch, { opacity: 1, y: 0, stagger: 0.1, duration: 1, ease: "power3.out" }); }
    });

    if (window.matchMedia("(pointer: fine)").matches) {
      document.querySelectorAll(".oji-v4 .magnetic").forEach(function (btn) {
        var strength = 18;
        btn.addEventListener("mousemove", function (e) {
          var r = btn.getBoundingClientRect();
          var x = e.clientX - r.left - r.width / 2;
          var y = e.clientY - r.top - r.height / 2;
          gsap.to(btn, { x: (x / r.width) * strength, y: (y / r.height) * strength, duration: 0.4, ease: "power2.out" });
        });
        btn.addEventListener("mouseleave", function () {
          gsap.to(btn, { x: 0, y: 0, duration: 0.7, ease: "elastic.out(1, 0.4)" });
        });
      });
    }
  }

  /* OJI FIX (T8, 2026-07-16): reveal fallback. The CSS in oji-v4-base.css hides
     .fade-up / hero micro-elements as soon as the ".oji-v4-js" class above is
     added — that reveal is normally done by initMotion() below. If GSAP/
     ScrollTrigger never loaded (CDN blocked, offline, ad-blocker) or initMotion()
     throws partway through, that reveal never runs and the page stays blank.
     ".oji-v4-no-gsap" is the matching fallback selector in oji-v4-base.css that
     force-reveals everything; only added on those failure paths, so normal GSAP
     operation (including the "prefers-reduced-motion" path, already handled by
     its own CSS media query) is completely unaffected. */
  if (!prefersReduced && window.gsap && window.ScrollTrigger) {
    document.fonts.ready.then(function () {
      try {
        initMotion();
        ScrollTrigger.refresh();
      } catch (err) {
        document.documentElement.classList.add("oji-v4-no-gsap");
      }
    });
  } else {
    document.querySelectorAll(".oji-v4 .ritual__step").forEach(function (s) { s.classList.add("is-active"); });
    if (!prefersReduced) document.documentElement.classList.add("oji-v4-no-gsap");
  }

  /* ============================================================
     SHOP LOGIC — gallery, bundle radios, qty, ATC label
     ============================================================ */
  var galleryImgs = document.querySelectorAll(".oji-v4 .shop__img");
  var thumbs = document.querySelectorAll(".oji-v4 .shop__thumb");

  function setGallery(n) {
    galleryImgs.forEach(function (img) { img.classList.toggle("is-active", img.dataset.gallery === String(n)); });
    thumbs.forEach(function (t) {
      var active = t.dataset.thumb === String(n);
      t.classList.toggle("is-active", active);
      t.setAttribute("aria-selected", active);
    });
  }
  thumbs.forEach(function (t) { t.addEventListener("click", function () { setGallery(t.dataset.thumb); }); });

  var atcLabel = document.getElementById("oji-v4-atc-label");
  /* OJI FIX 2026-08-18 (auditoría CRO + review): los CTAs del hero y del outro reflejan el
     pack/cantidad elegidos en el módulo de compra (antes mostraban y añadían siempre el
     precio del 1 Pack). Ambos llevan data-template con "%s" para el total. */
  var ctaPriceLabels = [
    document.getElementById("oji-v4-hero-cta-label"),
    document.getElementById("oji-v4-outro-cta-label")
  ].filter(Boolean);
  var qtyNum = document.getElementById("oji-v4-qty-num");
  var qtyInput = document.getElementById("oji-v4-qty-input");
  var atcbarMeta = document.getElementById("oji-v4-atcbar-meta");

  function refreshShopUI() {
    var total = state.priceCents * state.qty;
    if (atcLabel) atcLabel.textContent = (atcLabel.dataset.template || "Comprar ahora — %s").replace("%s", fmt(total));
    if (state.variantId) {
      ctaPriceLabels.forEach(function (el) {
        if (el.dataset.template) el.textContent = el.dataset.template.replace("%s", fmt(total));
      });
    }
    if (qtyNum) qtyNum.textContent = state.qty;
    if (qtyInput) qtyInput.value = state.qty;
    if (atcbarMeta) {
      /* OJI FIX 2026-08-17: "Default Title" is Shopify's internal name for the only variant of a
         product with no options (chasen). oji-v4-buy.liquid already empties data-label there, and
         the literal check keeps an older/cached markup from repainting it. No label = price only,
         separator included, so no orphan " · " is left. Real variants keep the exact same string. */
      var metaLabel = state.label && state.label !== "Default Title" ? state.label : "";
      var qtySuffix = state.qty > 1 ? "×" + state.qty : "";
      var metaHead = metaLabel && qtySuffix ? metaLabel + " " + qtySuffix : metaLabel || qtySuffix;
      atcbarMeta.textContent = metaHead ? metaHead + " · " + fmt(total) : fmt(total);
    }
  }

  bundleInputs.forEach(function (r) {
    r.addEventListener("change", function () {
      state.variantId = r.value;
      state.priceCents = Number(r.dataset.priceCents);
      state.label = r.dataset.label;
      setGallery(r.dataset.gallery);
      refreshShopUI();
    });
  });
  document.querySelectorAll(".oji-v4 [data-qty]").forEach(function (b) {
    b.addEventListener("click", function () {
      state.qty = Math.min(9, Math.max(1, state.qty + Number(b.dataset.qty)));
      refreshShopUI();
    });
  });

  /* ============================================================
     CART DRAWER — Shopify AJAX Cart API
     ============================================================ */
  var cartEl = document.getElementById("oji-v4-cart");
  var cartPanelEl = document.querySelector(".oji-v4 .cart__panel");
  var cartItemsEl = document.getElementById("oji-v4-cart-items");
  var cartEmptyEl = document.getElementById("oji-v4-cart-empty");
  var cartFootEl = document.getElementById("oji-v4-cart-foot");
  var cartCloseBtn = document.getElementById("oji-v4-cart-close");

  /* Fix 3 (pre-merge wave): role="dialog" aria-modal="true" needs focus management to be a real
     modal — move focus in on open, restore it on close, and trap Tab inside the panel. */
  var cartLastFocused = null;

  function getFocusable(container) {
    if (!container) return [];
    var nodes = container.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function cartTrapKeydown(e) {
    if (e.key === "Escape") { closeCart(); return; }
    if (e.key !== "Tab") return;
    var focusable = getFocusable(cartPanelEl);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openCart() {
    if (!cartEl) return;
    cartLastFocused = document.activeElement;
    cartEl.classList.add("is-open");
    cartEl.setAttribute("aria-hidden", "false");
    if (lenis) lenis.stop();
    document.body.style.overflow = "hidden";
    if (cartCloseBtn) cartCloseBtn.focus();
    document.addEventListener("keydown", cartTrapKeydown);
  }
  function closeCart() {
    if (!cartEl) return;
    cartEl.classList.remove("is-open");
    cartEl.setAttribute("aria-hidden", "true");
    if (lenis) lenis.start();
    document.body.style.overflow = "";
    document.removeEventListener("keydown", cartTrapKeydown);
    if (cartLastFocused && document.contains(cartLastFocused)) cartLastFocused.focus();
    cartLastFocused = null;
  }
  var cartBackdrop = document.getElementById("oji-v4-cart-backdrop");
  if (cartCloseBtn) cartCloseBtn.addEventListener("click", closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener("click", closeCart);

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  function addToCart(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || "No se pudo añadir al carrito"); });
        return fetchCart();
      })
      .then(function (cart) { renderCart(cart); openCart(); })
      .catch(function (err) { console.error("[oji-v4] add to cart:", err); window.alert(err.message); });
  }

  function changeLine(line, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || "No se pudo actualizar el carrito"); });
        return r.json();
      })
      .then(renderCart)
      .catch(function (err) { console.error("[oji-v4] cart change:", err); window.alert(err.message); });
  }

  function renderCart(cart) {
    if (!cartItemsEl) return;
    var count = cart.item_count;
    var headCount = document.getElementById("oji-v4-cart-head-count");
    if (headCount) headCount.textContent = count ? "(" + count + ")" : "";
    if (cartEmptyEl) cartEmptyEl.style.display = cart.items.length ? "none" : "";
    if (cartFootEl) cartFootEl.hidden = !cart.items.length;

    cartItemsEl.querySelectorAll(".cart-line").forEach(function (n) { n.remove(); });

    cart.items.forEach(function (item, i) {
      var line = i + 1;
      var el = document.createElement("div");
      el.className = "cart-line";
      var img = document.createElement("img");
      img.className = "cart-line__img";
      img.alt = "";
      if (item.image) img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/, "_180x$1$2");
      var mid = document.createElement("div");
      var name = document.createElement("p");
      name.className = "cart-line__name";
      name.textContent = item.product_title;
      var meta = document.createElement("p");
      meta.className = "cart-line__meta";
      meta.textContent = item.variant_title || "";
      var qtyWrap = document.createElement("span");
      qtyWrap.className = "cart-line__qty";
      var minus = document.createElement("button");
      minus.textContent = "−";
      minus.setAttribute("aria-label", "Reducir cantidad");
      minus.addEventListener("click", function () { changeLine(line, item.quantity - 1); });
      var qspan = document.createElement("span");
      qspan.textContent = item.quantity;
      var plus = document.createElement("button");
      plus.textContent = "+";
      plus.setAttribute("aria-label", "Aumentar cantidad");
      plus.addEventListener("click", function () { changeLine(line, item.quantity + 1); });
      qtyWrap.append(minus, qspan, plus);
      mid.append(name, meta, qtyWrap);
      var right = document.createElement("div");
      var price = document.createElement("p");
      price.className = "cart-line__price";
      price.textContent = fmt(item.final_line_price);
      var remove = document.createElement("button");
      remove.className = "cart-line__remove";
      remove.textContent = "Eliminar";
      remove.addEventListener("click", function () { changeLine(line, 0); });
      right.append(price, remove);
      el.append(img, mid, right);
      cartItemsEl.appendChild(el);
    });

    var subtotalEl = document.getElementById("oji-v4-cart-subtotal");
    if (subtotalEl) subtotalEl.textContent = fmt(cart.items_subtotal_price);

    var label = document.getElementById("oji-v4-cart-ship-label");
    var fill = document.getElementById("oji-v4-cart-bar-fill");
    if (label && fill && freeShipCents > 0) {
      var remaining = Math.max(0, freeShipCents - cart.items_subtotal_price);
      if (remaining > 0) {
        label.innerHTML = "Te faltan <strong>" + fmt(remaining) + "</strong> para el envío gratis";
      } else {
        label.innerHTML = "<strong>Envío gratis desbloqueado</strong> — silenciosamente, por nuestra cuenta";
      }
      fill.style.width = Math.min(100, (cart.items_subtotal_price / freeShipCents) * 100) + "%";
    }

    renderCartExtras(cart);
  }

  /* ============================================================
     CART EXTRAS (T15) — cross-sell del ritual dentro del drawer v4.

     La linea de confianza y las marcas de pago son estaticas (Liquid); lo unico
     que necesita JS es el cross-sell, porque este drawer se pinta en cliente y
     la regla tiene que re-evaluarse tras cada /cart/add.js y /cart/change.js.

     Regla (portada de snippets/oji-cart-extras.liquid):
       - carrito con el matcha 30g y SIN accesorio del ritual -> ofrece el set
         chasen (fallback chasen de bambu). Identica a la del halo drawer.
       - caso inverso, pedido explicito en T15: carrito con kit/bundle/accesorio
         y SIN matcha 30g -> ofrece el matcha 30g.
       - cualquier otra composicion (ambos, o ninguno) -> sin tarjeta.

     Los candidatos llegan serializados desde el Liquid del drawer
     (#oji-v4-crosssell-data, ver snippets/oji-v4-crosssell-offer.liquid).
     ============================================================ */
  var crossEl = document.getElementById("oji-v4-crosssell");
  var crossData = null;
  try {
    var crossDataEl = document.getElementById("oji-v4-crosssell-data");
    if (crossDataEl) crossData = JSON.parse(crossDataEl.textContent);
  } catch (err) {
    console.error("[oji-v4] crosssell data:", err);
  }

  function pickCrossSell(cart) {
    if (!crossData || !crossData.offers || !cart || !cart.items) return null;
    var ritualHandles = crossData.ritualHandles || [];
    var hasMatcha = false;
    var hasRitual = false;
    cart.items.forEach(function (item) {
      if (item.handle === crossData.matchaHandle) hasMatcha = true;
      if (ritualHandles.indexOf(item.handle) !== -1) hasRitual = true;
    });
    if (hasMatcha && !hasRitual) return crossData.offers.ritual;
    if (hasRitual && !hasMatcha) return crossData.offers.matcha;
    return null;
  }

  function renderCartExtras(cart) {
    if (!crossEl) return;
    var offer = pickCrossSell(cart);
    if (!offer || !offer.variantId) {
      crossEl.hidden = true;
      return;
    }

    crossEl.querySelectorAll("[data-oji-v4-crosssell-link]").forEach(function (a) {
      a.href = offer.url;
    });
    var titleEl = crossEl.querySelector("[data-oji-v4-crosssell-title]");
    if (titleEl) titleEl.textContent = offer.title;
    var priceEl = crossEl.querySelector("[data-oji-v4-crosssell-price]");
    if (priceEl) priceEl.textContent = fmt(offer.priceCents);

    var imgEl = crossEl.querySelector("[data-oji-v4-crosssell-img]");
    var mediaEl = crossEl.querySelector(".oji-cart-extras__crosssell-media");
    if (imgEl && mediaEl) {
      if (offer.image) {
        imgEl.src = offer.image;
        imgEl.alt = offer.imageAlt || "";
        mediaEl.hidden = false;
      } else {
        mediaEl.hidden = true;
      }
    }

    var addBtn = crossEl.querySelector("[data-oji-v4-crosssell-add]");
    if (addBtn) {
      addBtn.dataset.variantId = offer.variantId;
      addBtn.setAttribute("aria-label", "Agregar " + offer.title + " al carrito");
    }

    crossEl.hidden = false;
  }

  /* El boton es persistente (Liquid lo renderiza una vez y renderCartExtras solo
     rellena campos), asi que un listener directo basta — nada de delegacion. */
  var crossAddBtn = crossEl ? crossEl.querySelector("[data-oji-v4-crosssell-add]") : null;
  if (crossAddBtn) {
    crossAddBtn.addEventListener("click", function () {
      if (crossAddBtn.classList.contains("is-loading")) return;
      var variantId = crossAddBtn.dataset.variantId;
      if (!variantId) return;

      var labelEl = crossAddBtn.querySelector("[data-oji-v4-crosssell-label]");
      var idleLabel = labelEl ? labelEl.textContent : "";
      crossAddBtn.classList.add("is-loading");
      crossAddBtn.setAttribute("aria-busy", "true");
      if (labelEl) labelEl.textContent = crossAddBtn.dataset.strAdding || idleLabel;

      /* addToCart resuelve tanto en exito como en error (tiene su propio catch),
         asi que este then restaura el boton en ambos casos; si fue exito el
         repintado ya habra ocultado o cambiado la tarjeta. */
      addToCart(variantId, 1).then(function () {
        crossAddBtn.classList.remove("is-loading");
        crossAddBtn.removeAttribute("aria-busy");
        if (labelEl) labelEl.textContent = idleLabel;
      });
    });
  }

  /* OJI FIX 2026-08-18 (auditoría CRO, AOV): resolución de variante unificada para todos los
     CTAs de compra. Antes, un botón con data-variant-id (hero, outro) añadía SIEMPRE 1 unidad
     de la primera variante aunque el usuario hubiera elegido el 2/3 Pack en el módulo de
     compra. Ahora el estado del selector manda; data-variant-id queda como respaldo para
     páginas sin módulo de compra. */
  function resolvePurchase(btn) {
    if (state.variantId) return { variantId: state.variantId, qty: state.qty };
    if (btn.dataset.variantId) return { variantId: btn.dataset.variantId, qty: 1 };
    return null;
  }

  document.querySelectorAll(".oji-v4 [data-add-to-cart]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var pick = resolvePurchase(btn);
      if (!pick) return;
      addToCart(pick.variantId, pick.qty);
    });
  });

  /* ============================================================
     COMPRAR AHORA — OJI FIX 2026-08-18 (auditoría CRO, AOV): antes saltaba
     directo a /checkout, esquivando el drawer y con él la única mecánica de
     cross-sell del funnel. Ahora añade al carrito y abre el drawer (donde
     vive el cross-sell y el CTA "Finalizar compra"); el botón se deshabilita
     mientras la petición está en vuelo para evitar dobles añadidos.
     El no-JS fallback no cambia: el botón sigue siendo type="submit" dentro
     de {% form 'product' %} (POST nativo a /cart/add) — ver
     sections/oji-v4-buy.liquid. Binding querySelectorAll: cubre el módulo
     de compra y el outro.
     ============================================================ */
  document.querySelectorAll(".oji-v4 [data-buy-now]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var pick = resolvePurchase(btn);
      if (!pick) return;
      btn.disabled = true;
      btn.classList.add("is-loading");
      /* addToCart resuelve tanto en éxito como en error (tiene su propio catch). */
      addToCart(pick.variantId, pick.qty).then(function () {
        btn.disabled = false;
        btn.classList.remove("is-loading");
      });
    });
  });

  /* ============================================================
     RITUAL CAROUSEL DOTS (mobile snap-scroll)
     ============================================================ */
  var ritualTrack = document.getElementById("oji-v4-ritual-steps");
  var ritualDots = document.querySelectorAll("#oji-v4-ritual-dots span");
  if (ritualTrack && ritualDots.length) {
    var dotRaf = null;
    ritualTrack.addEventListener("scroll", function () {
      if (dotRaf) return;
      dotRaf = requestAnimationFrame(function () {
        dotRaf = null;
        var max = ritualTrack.scrollWidth - ritualTrack.clientWidth;
        if (max <= 0) return;
        var i = Math.min(3, Math.round((ritualTrack.scrollLeft / max) * 3));
        ritualDots.forEach(function (d, j) { d.classList.toggle("is-active", j === i); });
      });
    }, { passive: true });
  }

  /* ============================================================
     STICKY MOBILE ADD-TO-CART BAR
     ============================================================ */
  /* REVERT 2026-08-18 (pedido del dueño): la variante de doble observer (aparecer desde el
     hero y ocultarse con el módulo de compra en pantalla) resultó intermitente en scroll
     real — el dueño la reportó "bugeada" y pidió el comportamiento original. Este es el
     bloque previo, byte a byte: la barra aparece únicamente tras dejar atrás la fila del
     módulo de compra. Si algún día se reintenta la aparición temprana, prototiparla en un
     tema preview con QA visual antes de tocar esto. */
  var atcbar = document.getElementById("oji-v4-atcbar");
  var shopRow = document.querySelector(".oji-v4 .shop__row");
  if (atcbar && shopRow && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var passedAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      atcbar.classList.toggle("is-visible", passedAbove);
      atcbar.setAttribute("aria-hidden", String(!passedAbove));
    }, { rootMargin: "-70px 0px 0px 0px" }).observe(shopRow);
  }

  /* ============================================================
     REVIEW FORM — front-end demo only.
     TODO(Loox): replace with the Loox review widget / deep link
     once the app block is wired; nothing is submitted anywhere.
     ============================================================ */
  var rfForm = document.getElementById("oji-v4-review-form");
  var rfToggle = document.getElementById("oji-v4-review-toggle");
  if (rfForm && rfToggle) {
    var rfStars = rfForm.querySelectorAll(".review-form__stars button");
    var rfPhotoInput = document.getElementById("oji-v4-rf-photo");
    var rfPhotoPreview = document.getElementById("oji-v4-rf-photo-preview");
    var rfPhotoLabel = document.getElementById("oji-v4-rf-photo-label");
    var rfError = document.getElementById("oji-v4-rf-error");
    var rfSuccess = document.getElementById("oji-v4-review-success");
    var rfRating = 0;
    var rfPhotoData = null;

    rfToggle.addEventListener("click", function () {
      var open = rfForm.hidden;
      rfForm.hidden = !open;
      if (rfSuccess) rfSuccess.hidden = true;
      rfToggle.setAttribute("aria-expanded", String(open));
      rfToggle.querySelector("span").textContent = open ? "Cerrar" : "Escribe una reseña";
      if (open) document.getElementById("oji-v4-rf-name").focus();
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    });

    rfStars.forEach(function (btn) {
      btn.addEventListener("click", function () {
        rfRating = Number(btn.dataset.star);
        rfStars.forEach(function (b) { b.classList.toggle("is-on", Number(b.dataset.star) <= rfRating); });
      });
    });

    if (rfPhotoInput) {
      rfPhotoInput.addEventListener("change", function () {
        var file = rfPhotoInput.files && rfPhotoInput.files[0];
        if (!file) return;
        var reader = new FileReader();
        reader.onload = function () {
          rfPhotoData = reader.result;
          rfPhotoPreview.src = rfPhotoData;
          rfPhotoPreview.hidden = false;
          rfPhotoLabel.textContent = file.name;
        };
        reader.readAsDataURL(file);
      });
    }

    rfForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var name = document.getElementById("oji-v4-rf-name").value.trim();
      var text = document.getElementById("oji-v4-rf-text").value.trim();
      if (!rfRating || !name || !text) { rfError.hidden = false; return; }
      rfError.hidden = true;

      var card = document.createElement("figure");
      card.className = "review";
      if (rfPhotoData) {
        var img = document.createElement("img");
        img.className = "review__photo";
        img.src = rfPhotoData;
        img.alt = "Foto de " + name;
        card.appendChild(img);
      }
      var stars = document.createElement("p");
      stars.className = "stars";
      stars.setAttribute("aria-label", rfRating + " estrellas");
      stars.textContent = "★".repeat(rfRating) + "☆".repeat(5 - rfRating);
      var quote = document.createElement("blockquote");
      quote.textContent = "“" + text + "”";
      var cap = document.createElement("figcaption");
      var strong = document.createElement("strong");
      strong.textContent = name;
      var meta = document.createElement("span");
      meta.textContent = "Ahora mismo · Pendiente de verificación";
      cap.append(strong, meta);
      card.append(stars, quote, cap);
      document.getElementById("oji-v4-reviews-grid").prepend(card);

      rfForm.reset();
      rfRating = 0;
      rfStars.forEach(function (b) { b.classList.remove("is-on"); });
      rfPhotoData = null;
      if (rfPhotoPreview) rfPhotoPreview.hidden = true;
      if (rfPhotoLabel) rfPhotoLabel.innerHTML = "＋ Añade una foto <em>(opcional — enséñanos tu chawan)</em>";
      rfForm.hidden = true;
      rfSuccess.hidden = false;
      rfToggle.setAttribute("aria-expanded", "false");
      rfToggle.querySelector("span").textContent = "Escribe una reseña";
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    });
  }

  refreshShopUI();
  fetchCart().then(renderCart).catch(function () {});
})();
